/* Plansza tła: losowo rozmieszczone motywy laboratoryjne, przewijane wolniej
   niż treść, rozbłyskujące pojedynczo, a przy przewijaniu wszystkie naraz.

   Rysunki powstają przy każdym otwarciu strony, więc układ nigdy nie jest ten
   sam. Geometria siedzi tutaj, a nie w pliku SVG, bo inaczej trzeba by ją
   trzymać w dwóch miejscach naraz. */
(function () {
  'use strict';

  var warstwa = document.querySelector('.lpn-tlo');
  if (!warstwa) return;
  var plansza = warstwa.querySelector('.lpn-tlo__plansza');
  if (!plansza) return;

  // ── pokrętła ────────────────────────────────────────────────────────────
  var UDZIAL = 0.28;      // 0 — plansza stoi, 1 — jedzie razem z treścią
  var GESTOSC = 20000;    // px² planszy na jeden motyw
  var MAKS = 190;         // górny limit, żeby długa strona nie zabiła rysowania
  var SILA_BAZA = 0.42;   // jasność motywów w spoczynku
  var SILA_SZCZYT = 1;    // przy szybkim przewijaniu
  var PROG_PREDKOSCI = 28; // px na klatkę, przy których blask jest pełny

  // Potrząśnięcie telefonem — próg i pełnia liczone z przyrostu przyspieszenia
  // między próbkami (m/s²). Odjęcie poprzedniej próbki usuwa grawitację.
  var WSTRZAS_PROG = 14;
  var WSTRZAS_PELNIA = 35;
  var WSTRZAS_ODSTEP = 140;  // ms — jak często wolno dokładać pojedyncze rozbłyski
  // iOS 13+ wpuszcza czujnik dopiero po zgodzie, a o zgodę wolno spytać tylko
  // w odpowiedzi na gest. Ustaw na false, jeśli systemowe okienko z pytaniem
  // o dostęp do ruchu ma się w sklepie nie pojawiać — wtedy zostaje Android.
  var PYTAJ_O_RUCH = true;

  var spokoj = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ── drobiazgi ───────────────────────────────────────────────────────────
  function mdz(a, b) { return a + Math.random() * (b - a); }
  function calk(a, b) { return Math.round(mdz(a, b)); }
  function z(x) { return Math.round(x * 10) / 10; }

  var KRESKA = 'fill="none" stroke="#3D99FF" stroke-width="1.1" vector-effect="non-scaling-stroke"';
  var PLAMA = 'fill="#3D99FF"';

  function kropka(x, y, r) {
    return '<circle cx="' + z(x) + '" cy="' + z(y) + '" r="' + z(r) + '" ' + PLAMA + '/>';
  }
  function sciezka(d) { return '<path d="' + d + '" ' + KRESKA + '/>'; }

  function wierzcholki(r, n, obrot) {
    var t = [];
    for (var i = 0; i < n; i++) {
      var a = (obrot + (i * 360) / n) * Math.PI / 180;
      t.push(z(r * Math.cos(a)) + ',' + z(r * Math.sin(a)));
    }
    return t.join(' ');
  }

  // ── motywy ──────────────────────────────────────────────────────────────
  // Każdy rysuje się wokół punktu (0,0); skala i obrót idą z transformacji.
  var ZESTAWY = {};

  // Zestaw domyślny: rysunki laboratoryjne (strona główna i pozostałe strony).
  ZESTAWY.laboratorium = [
    function pierscien() {
      var r = mdz(34, 52), s = '';
      s += '<polygon points="' + wierzcholki(r, 6, 30) + '" ' + KRESKA + '/>';
      s += '<polygon points="' + wierzcholki(r * 0.7, 6, 30) + '" fill="none" ' +
           'stroke="#3D99FF" stroke-width="0.7" vector-effect="non-scaling-stroke" opacity=".6"/>';
      for (var i = 0; i < 6; i++) {
        var a = (30 + i * 60) * Math.PI / 180;
        s += kropka(r * Math.cos(a), r * Math.sin(a), 2.6);
      }
      if (Math.random() < 0.7) {
        s += sciezka('M' + z(r) + ' 0l' + z(mdz(22, 36)) + ' ' + z(mdz(-22, -12)));
      }
      return s;
    },

    function atom() {
      var rx = mdz(46, 66), ry = rx * mdz(0.3, 0.42), s = '';
      for (var i = 0; i < 3; i++) {
        s += '<ellipse cx="0" cy="0" rx="' + z(rx) + '" ry="' + z(ry) + '" ' + KRESKA +
             ' transform="rotate(' + i * 60 + ')"/>';
      }
      s += kropka(0, 0, 4.2);
      s += kropka(rx, 0, 2.8);
      s += kropka(-rx * 0.5, -ry * 0.87 * 2, 2.4);
      return s;
    },

    function lancuch() {
      var n = calk(3, 5), krok = mdz(38, 56), s = '', d = '', p = [];
      for (var i = 0; i < n; i++) {
        p.push([i * krok - ((n - 1) * krok) / 2, (i % 2 ? 1 : -1) * mdz(10, 20)]);
      }
      d = 'M' + p.map(function (t) { return z(t[0]) + ' ' + z(t[1]); }).join('L');
      s += sciezka(d);
      var g = p[calk(1, n - 2)];
      s += sciezka('M' + z(g[0]) + ' ' + z(g[1]) + 'l' + z(mdz(-14, 14)) + ' ' + z(mdz(28, 44)));
      p.forEach(function (t) { s += kropka(t[0], t[1], 3.2); });
      return s;
    },

    function fala() {
      var s = '', n = calk(3, 4);
      for (var i = 1; i <= n; i++) {
        s += '<circle cx="0" cy="0" r="' + z(i * mdz(14, 19)) + '" fill="none" stroke="#3D99FF" ' +
             'stroke-width="1.1" vector-effect="non-scaling-stroke" opacity="' +
             z(1 - i / (n + 1.4)) + '"/>';
      }
      return s + kropka(0, 0, 3);
    },

    function celownik() {
      var r = mdz(14, 22);
      return sciezka('M' + z(-r * 1.9) + ' 0h' + z(r * 3.8) + 'M0 ' + z(-r * 1.9) + 'v' + z(r * 3.8)) +
             '<circle cx="0" cy="0" r="' + z(r) + '" ' + KRESKA + '/>';
    },

    function podzialka() {
      var dl = mdz(60, 110), n = calk(4, 7), s = sciezka('M' + z(-dl / 2) + ' 0h' + z(dl)), i;
      for (i = 0; i <= n; i++) {
        var x = -dl / 2 + (dl * i) / n;
        var h = i % 2 === 0 ? 7 : 4;
        s += sciezka('M' + z(x) + ' ' + z(-h) + 'v' + z(h * 2));
      }
      return s;
    },

    function wykres() {
      var szer = mdz(70, 110), wys = mdz(26, 42), n = calk(5, 8), d = '', i;
      for (i = 0; i <= n; i++) {
        var x = -szer / 2 + (szer * i) / n;
        var y = Math.sin((i / n) * Math.PI * mdz(1.4, 2.6)) * (wys / 2);
        d += (i ? 'L' : 'M') + z(x) + ' ' + z(y);
      }
      return sciezka('M' + z(-szer / 2) + ' ' + z(wys / 2 + 8) + 'h' + z(szer)) +
             sciezka('M' + z(-szer / 2) + ' ' + z(-wys / 2 - 8) + 'v' + z(wys + 16)) +
             sciezka(d);
    },

    function konstelacja() {
      var n = calk(4, 6), r = mdz(34, 58), p = [], s = '', i;
      for (i = 0; i < n; i++) {
        var a = mdz(0, 360) * Math.PI / 180, d = mdz(r * 0.35, r);
        p.push([d * Math.cos(a), d * Math.sin(a)]);
      }
      for (i = 1; i < n; i++) {
        s += sciezka('M' + z(p[i - 1][0]) + ' ' + z(p[i - 1][1]) + 'L' + z(p[i][0]) + ' ' + z(p[i][1]));
      }
      p.forEach(function (t) { s += kropka(t[0], t[1], mdz(1.8, 3.2)); });
      return s;
    },

    function krysztal() {
      var b = mdz(26, 38), s = '', kol = 3, w, k;
      for (w = 0; w < kol; w++) {
        for (k = 0; k <= w; k++) {
          var x = (k - w / 2) * b;
          var y = (w - (kol - 1) / 2) * b * 0.87;
          s += kropka(x, y, 2.4);
          if (k < w) s += sciezka('M' + z(x) + ' ' + z(y) + 'l' + z(b) + ' 0');
          if (w < kol - 1) {
            s += sciezka('M' + z(x) + ' ' + z(y) + 'l' + z(-b / 2) + ' ' + z(b * 0.87));
            s += sciezka('M' + z(x) + ' ' + z(y) + 'l' + z(b / 2) + ' ' + z(b * 0.87));
          }
        }
      }
      return s;
    }
  ];

  // ── komórki Pyrocystis lunula (strony produktów glonowych) ──────────────
  // Kształt półksiężyca to cecha rozpoznawcza gatunku; przez większość życia
  // komórka jest nieruchomą cystą. Rozmnaża się bezpłciowo — wewnątrz powłoki
  // macierzystej powstają aplanospory, które pęcznieją do kształtu rodzica,
  // a po ich wyjściu zostaje pusta, sierpowata powłoka. Chloroplasty zmieniają
  // rozmieszczenie w cyklu dnia i nocy. Stąd te siedem odmian.

  // Obrys komórki: dwa łuki spięte w zaostrzonych końcach.
  function obrysSierpa(dl, wygiecie, grubosc) {
    var zew = dl * wygiecie;
    var wew = zew - grubosc;
    return 'M' + z(-dl / 2) + ' 0' +
           'C' + z(-dl / 3) + ' ' + z(-zew) + ',' + z(dl / 3) + ' ' + z(-zew) + ',' + z(dl / 2) + ' 0' +
           'C' + z(dl / 3) + ' ' + z(-wew) + ',' + z(-dl / 3) + ' ' + z(-wew) + ',' + z(-dl / 2) + ' 0Z';
  }

  // Punkt na osi komórki dla t z przedziału 0–1.
  function osSierpa(dl, wygiecie, grubosc, t) {
    var srodek = (dl * wygiecie) - grubosc / 2;
    return [(-dl / 2) + dl * t, -0.75 * srodek * 4 * t * (1 - t)];
  }

  // Ile miejsca jest w komórce w punkcie t — przy zaostrzonych końcach prawie
  // nic, więc ziarna muszą tam maleć, inaczej wychodzą poza obrys.
  function profil(t) { return 0.35 + 0.65 * 4 * t * (1 - t); }

  ZESTAWY.lunula = [
    function komorkaDzien() {
      var dl = mdz(96, 150), wyg = mdz(0.3, 0.4), gr = dl * mdz(0.21, 0.28);
      var s = sciezka(obrysSierpa(dl, wyg, gr));
      for (var i = 0; i < 9; i++) {
        var t = 0.28 + (0.44 * i) / 8;
        var p = osSierpa(dl, wyg, gr, t);
        s += kropka(p[0], p[1], mdz(2, 3.2) * profil(t));
      }
      return s;
    },

    function komorkaNoc() {
      var dl = mdz(96, 150), wyg = mdz(0.3, 0.4), gr = dl * mdz(0.22, 0.3);
      var s = sciezka(obrysSierpa(dl, wyg, gr));
      for (var i = 0; i < 8; i++) {
        var p = osSierpa(dl, wyg, gr, mdz(0.43, 0.57));
        s += kropka(p[0] + mdz(-5, 5), p[1] + mdz(-3, 3), mdz(2.2, 3.6));
      }
      return s;
    },

    function powloka() {
      var dl = mdz(100, 156), zew = dl * 0.35, wew = zew - dl * mdz(0.21, 0.27);
      // Otwór, którym wyszła zawartość — górny łuk urwany w jednym miejscu.
      return '<path d="M' + z(-dl / 2) + ' 0C' + z(-dl / 3) + ' ' + z(-zew) + ',' +
             z(-dl / 12) + ' ' + z(-zew) + ',' + z(dl / 10) + ' ' + z(-zew * 0.82) + '" ' + KRESKA + '/>' +
             '<path d="M' + z(dl / 4) + ' ' + z(-zew * 0.66) + 'C' + z(dl / 3) + ' ' + z(-zew * 0.4) + ',' +
             z(dl / 2.4) + ' ' + z(-zew * 0.2) + ',' + z(dl / 2) + ' 0" ' + KRESKA + '/>' +
             '<path d="M' + z(dl / 2) + ' 0C' + z(dl / 3) + ' ' + z(-wew) + ',' +
             z(-dl / 3) + ' ' + z(-wew) + ',' + z(-dl / 2) + ' 0" ' + KRESKA + '/>';
    },

    function komorkaZKomorkamiPotomnymi() {
      // Aplanospory pęcznieją do kształtu rodzica, więc w środku powłoki
      // macierzystej siedzą małe sierpy, a nie kule.
      var dl = mdz(110, 156), wyg = mdz(0.32, 0.42), gr = dl * mdz(0.26, 0.33);
      var s = sciezka(obrysSierpa(dl, wyg, gr));
      var ile = calk(2, 3);
      for (var i = 0; i < ile; i++) {
        var t = 0.5 + (i - (ile - 1) / 2) * 0.17;
        var p = osSierpa(dl, wyg, gr, t);
        var mala = dl * mdz(0.2, 0.27);
        s += '<g transform="translate(' + z(p[0]) + ' ' + z(p[1] + gr * 0.16) + ') rotate(' +
             calk(-16, 16) + ')">' +
             sciezka(obrysSierpa(mala, mdz(0.4, 0.5), mala * mdz(0.3, 0.38))) + '</g>';
      }
      return s;
    },

    function mlodaKomorka() {
      var dl = mdz(58, 84), wyg = mdz(0.4, 0.5), gr = dl * mdz(0.3, 0.38);
      var s = sciezka(obrysSierpa(dl, wyg, gr));
      for (var i = 0; i < 5; i++) {
        var t = 0.32 + (0.36 * i) / 4;
        var p = osSierpa(dl, wyg, gr, t);
        s += kropka(p[0], p[1], mdz(1.8, 2.8) * profil(t));
      }
      return s;
    },

    function paraKomorek() {
      // Dwie komórki tuż po podziale: ten sam kierunek wygięcia, lekko rozsunięte.
      var dl = mdz(78, 112), wyg = mdz(0.34, 0.44), gr = dl * mdz(0.22, 0.29);
      var odstep = gr * mdz(1.4, 1.9);
      var s = sciezka(obrysSierpa(dl, wyg, gr));
      s += '<g transform="translate(' + z(mdz(-8, 8)) + ' ' + z(odstep) + ')">' +
           sciezka(obrysSierpa(dl * mdz(0.9, 1), wyg, gr)) + '</g>';
      return s;
    }
  ];

  // ── plazmodium Physarum polycephalum (strona zestawu ze śluzowcem) ──────
  // Śluzowiec rozrasta się w sieć żyłek: grube „arterie” rozwidlają się na
  // cieńsze odnogi, a te potrafią zejść się z powrotem (anastomoza), zamykając
  // pętlę. Front wzrostu jest wachlarzowaty. Stąd te sześć odmian — nieregularne
  // krzywe, w przeciwieństwie do geometrii pozostałych zestawów.

  function rurka(x1, y1, kx, ky, x2, y2, grubosc) {
    return '<path d="M' + z(x1) + ' ' + z(y1) + 'Q' + z(kx) + ' ' + z(ky) + ' ' + z(x2) + ' ' + z(y2) +
           '" fill="none" stroke="#3D99FF" stroke-width="' + z(grubosc) +
           '" stroke-linecap="round" vector-effect="non-scaling-stroke"/>';
  }

  // Łuk wygięty prostopadle do odcinka. Bez tego punkty kontrolne wypadają
  // blisko prostej i sieć wygląda jak wielokąt, a nie jak żyłki.
  function wygieta(a, b, sila, grubosc) {
    var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
    var dx = b[0] - a[0], dy = b[1] - a[1];
    var dl = Math.sqrt(dx * dx + dy * dy) || 1;
    var odchylenie = mdz(-sila, sila);
    return rurka(a[0], a[1], mx + (-dy / dl) * odchylenie, my + (dx / dl) * odchylenie,
                 b[0], b[1], grubosc);
  }

  // Rekurencyjne rozwidlenie; głębokość trzymana krótko, bo każdy poziom
  // podwaja liczbę ścieżek, a motywów na planszy są setki.
  function rozgalezienie(x, y, kat, dl, grubosc, glebokosc, czesci) {
    var zgiecie = mdz(-0.4, 0.4);
    var x2 = x + Math.cos(kat + zgiecie) * dl;
    var y2 = y + Math.sin(kat + zgiecie) * dl;
    var kx = x + Math.cos(kat) * dl * 0.55;
    var ky = y + Math.sin(kat) * dl * 0.55;
    czesci.push(rurka(x, y, kx, ky, x2, y2, grubosc));
    if (glebokosc <= 0) return;
    var ile = Math.random() < 0.7 ? 2 : 1;
    for (var i = 0; i < ile; i++) {
      var obrot = (ile === 1 ? mdz(-0.5, 0.5) : (i === 0 ? -1 : 1) * mdz(0.3, 0.8));
      rozgalezienie(x2, y2, kat + zgiecie + obrot, dl * mdz(0.58, 0.8),
                    Math.max(0.7, grubosc * 0.7), glebokosc - 1, czesci);
    }
  }

  ZESTAWY.physarum = [
    function zylka() {
      var c = [];
      rozgalezienie(0, 0, mdz(0, 6.28), mdz(34, 52), mdz(2.4, 3.6), 3, c);
      return c.join('');
    },

    function wachlarz() {
      // Front wzrostu: pęk żyłek o nierównej długości, spięty na końcach
      // krótkimi mostkami błony.
      var r = mdz(40, 62), rozpiecie = mdz(1.1, 1.8), kat0 = -Math.PI / 2 - rozpiecie / 2;
      var c = [], konce = [], ile = calk(5, 7), i;
      for (i = 0; i <= ile; i++) {
        var k = kat0 + (rozpiecie * i) / ile + mdz(-0.07, 0.07);
        var dl = r * mdz(0.66, 1);
        var koniec = [Math.cos(k) * dl, Math.sin(k) * dl];
        konce.push(koniec);
        c.push(wygieta([0, 0], koniec, dl * 0.12, mdz(1.1, 2.3)));
      }
      for (i = 1; i < konce.length; i++) {
        if (Math.random() < 0.7) {
          c.push(wygieta(konce[i - 1], konce[i], mdz(3, 9), mdz(0.7, 1.2)));
        }
      }
      c.push(kropka(0, 0, 2.6));
      return c.join('');
    },

    function petla() {
      // Anastomoza: odnoga rozdziela się i schodzi z powrotem, zamykając oczko.
      var dl = mdz(56, 90), g = mdz(1.6, 2.6);
      var a = [-dl / 2, 0], b = [dl / 2, mdz(-14, 14)];
      var c = [wygieta(a, b, mdz(20, 38), g), wygieta(a, b, mdz(20, 38), g)];
      var kat = mdz(-0.8, 0.8);
      c.push(wygieta(b, [b[0] + Math.cos(kat) * mdz(26, 44), b[1] + Math.sin(kat) * mdz(26, 44)],
                     10, g * 0.75));
      c.push(wygieta(a, [a[0] - mdz(20, 38), a[1] + mdz(-24, 24)], 10, g * 0.7));
      c.push(kropka(a[0], a[1], 2.4));
      c.push(kropka(b[0], b[1], 2.4));
      return c.join('');
    },

    function siec() {
      // Kilka węzłów spiętych wygiętymi żyłkami, z odnogami wychodzącymi poza sieć.
      var n = calk(4, 6), p = [], c = [], i;
      for (i = 0; i < n; i++) p.push([mdz(-52, 52), mdz(-42, 42)]);
      for (i = 1; i < n; i++) c.push(wygieta(p[i - 1], p[i], mdz(12, 30), mdz(1.4, 2.4)));
      c.push(wygieta(p[n - 1], p[0], mdz(14, 34), mdz(1.3, 2.2)));
      for (i = 0; i < n; i++) {
        if (Math.random() < 0.55) {
          var kat = mdz(0, 6.28), dl = mdz(20, 40);
          c.push(wygieta(p[i], [p[i][0] + Math.cos(kat) * dl, p[i][1] + Math.sin(kat) * dl],
                         9, mdz(0.9, 1.6)));
        }
      }
      p.forEach(function (t) { c.push(kropka(t[0], t[1], mdz(1.9, 3))); });
      return c.join('');
    },

    function zerowisko() {
      // Płatek owsiany i żyłki zbiegające się do niego.
      var r = mdz(6, 10), ile = calk(3, 5), c = [], i;
      c.push('<ellipse cx="0" cy="0" rx="' + z(r * 1.4) + '" ry="' + z(r) + '" ' + KRESKA +
             ' transform="rotate(' + calk(0, 179) + ')"/>');
      for (i = 0; i < ile; i++) {
        var a = mdz(0, 6.28), dl = mdz(30, 58);
        c.push(rurka(Math.cos(a) * r, Math.sin(a) * r,
                     Math.cos(a) * dl * 0.5 + mdz(-12, 12), Math.sin(a) * dl * 0.5 + mdz(-12, 12),
                     Math.cos(a) * dl, Math.sin(a) * dl, mdz(1.2, 2.4)));
      }
      return c.join('');
    },

    function odnoga() {
      // Pojedyncza pełzająca żyłka z drobnymi bocznymi wypustkami.
      var dl = mdz(80, 130), c = [], i;
      var x1 = -dl / 2, x2 = dl / 2, wygiecie = mdz(-30, 30);
      c.push(rurka(x1, 0, 0, wygiecie, x2, 0, mdz(2, 3.2)));
      var ile = calk(3, 5);
      for (i = 1; i <= ile; i++) {
        var t = i / (ile + 1);
        var bx = x1 + dl * t;
        var by = wygiecie * 2 * t * (1 - t);
        var kier = Math.random() < 0.5 ? -1 : 1;
        c.push(rurka(bx, by, bx + mdz(-8, 8), by + kier * mdz(8, 16),
                     bx + mdz(-14, 14), by + kier * mdz(18, 32), mdz(0.9, 1.6)));
      }
      return c.join('');
    }
  ];

  // Strony spoza produktów pokazują całą pulę. Składana z tego, co akurat jest
  // w ZESTAWY, więc każdy dołożony zestaw wchodzi do puli sam z siebie.
  ZESTAWY.wszystko = [];
  for (var nazwaZestawu in ZESTAWY) {
    if (ZESTAWY.hasOwnProperty(nazwaZestawu) && nazwaZestawu !== 'wszystko') {
      ZESTAWY.wszystko = ZESTAWY.wszystko.concat(ZESTAWY[nazwaZestawu]);
    }
  }

  var MOTYWY = ZESTAWY[warstwa.getAttribute('data-wzor')] || ZESTAWY.wszystko;

  // ── budowa planszy ──────────────────────────────────────────────────────
  var motywy = [];
  var ostatniaSzer = 0, ostatniaWys = 0;

  function wysokoscStrony() {
    var d = document.documentElement, b = document.body;
    return Math.max(d.scrollHeight, b ? b.scrollHeight : 0, d.clientHeight);
  }

  function zbuduj() {
    var szer = warstwa.clientWidth || window.innerWidth;
    var okno = window.innerHeight;
    var wys = Math.round(okno + Math.max(0, wysokoscStrony() - okno) * UDZIAL);

    plansza.style.height = wys + 'px';
    ostatniaSzer = szer;
    ostatniaWys = wys;

    var ile = Math.min(MAKS, Math.max(8, Math.round((szer * wys) / GESTOSC)));
    // Rozstawiamy po jednym na komórkę siatki i przesuwamy losowo w jej obrębie:
    // czysty los potrafi zbić wszystko w kupki i zostawić puste połacie.
    var kol = Math.max(1, Math.round(Math.sqrt((ile * szer) / wys)));
    var wie = Math.max(1, Math.ceil(ile / kol));
    var szerK = szer / kol, wysK = wys / wie;

    var czesci = ['<svg class="lpn-tlo__rysunek" xmlns="http://www.w3.org/2000/svg" width="' +
                  szer + '" height="' + wys + '" viewBox="0 0 ' + szer + ' ' + wys + '">'];

    for (var w = 0; w < wie; w++) {
      for (var k = 0; k < kol; k++) {
        if (czesci.length - 1 >= ile) break;
        var x = szerK * (k + mdz(0.15, 0.85));
        var y = wysK * (w + mdz(0.15, 0.85));
        var rysuj = MOTYWY[Math.floor(Math.random() * MOTYWY.length)];
        czesci.push(
          '<g class="lpn-motyw" style="--o:' + z(mdz(0.32, 0.7)) + '" transform="translate(' +
          z(x) + ' ' + z(y) + ') rotate(' + calk(0, 359) + ') scale(' + z(mdz(0.6, 1.35)) + ')">' +
          rysuj() + '</g>'
        );
      }
    }
    czesci.push('</svg>');

    var poprzedni = plansza.querySelector('svg');
    if (poprzedni) poprzedni.parentNode.removeChild(poprzedni);
    plansza.insertAdjacentHTML('beforeend', czesci.join(''));
    motywy = plansza.querySelectorAll('.lpn-motyw');
  }

  // ── paralaksa i blask od przewijania ────────────────────────────────────
  var poprzedniY = window.pageYOffset || 0;
  var blask = 0;
  var chodzi = false;

  function przesun(y) {
    plansza.style.transform = 'translate3d(0,' + (-y * UDZIAL).toFixed(1) + 'px,0)';
  }

  function klatka() {
    var y = window.pageYOffset || 0;
    var skok = Math.abs(y - poprzedniY);
    poprzedniY = y;

    przesun(y);

    blask = Math.max(blask * 0.93, Math.min(skok / PROG_PREDKOSCI, 1));
    warstwa.style.setProperty(
      '--lpn-sila',
      (SILA_BAZA + blask * (SILA_SZCZYT - SILA_BAZA)).toFixed(3)
    );

    if (blask > 0.004 || skok > 0) {
      requestAnimationFrame(klatka);
    } else {
      chodzi = false;
    }
  }

  function ruszyloSie() {
    if (chodzi) return;
    chodzi = true;
    requestAnimationFrame(klatka);
  }

  // ── pojedyncze rozbłyski ────────────────────────────────────────────────
  var zegar = null;

  function migaj() {
    if (!document.hidden && motywy.length) {
      var ile = calk(2, 4);
      for (var i = 0; i < ile; i++) {
        (function (el) {
          if (!el) return;
          el.classList.add('lpn-blysk');
          setTimeout(function () { el.classList.remove('lpn-blysk'); }, calk(240, 560));
        })(motywy[Math.floor(Math.random() * motywy.length)]);
      }
    }
    zegar = setTimeout(migaj, calk(170, 680));
  }

  // ── potrząśnięcie telefonem ─────────────────────────────────────────────
  // Pasuje do rzeczy, którą sklep sprzedaje: kultura lunuli świeci właśnie po
  // poruszeniu naczyniem.
  var ostatniaProbka = null;
  var ostatniWstrzas = 0;

  function pobudz(moc, zRozblyskami) {
    blask = Math.max(blask, Math.min(moc, 1));
    warstwa.style.setProperty(
      '--lpn-sila',
      (SILA_BAZA + blask * (SILA_SZCZYT - SILA_BAZA)).toFixed(3)
    );
    if (!chodzi) {
      chodzi = true;
      requestAnimationFrame(klatka);
    }
    if (!zRozblyskami) return;
    // Przy mocnym szarpnięciu dokładamy garść pojedynczych rozbłysków.
    var ile = 2 + Math.round(Math.min(moc, 1) * 8);
    for (var i = 0; i < ile && motywy.length; i++) {
      (function (el) {
        if (!el) return;
        el.classList.add('lpn-blysk');
        setTimeout(function () { el.classList.remove('lpn-blysk'); }, calk(240, 620));
      })(motywy[Math.floor(Math.random() * motywy.length)]);
    }
  }

  function odczytRuchu(zdarzenie) {
    var a = zdarzenie.accelerationIncludingGravity || zdarzenie.acceleration;
    if (!a || a.x === null) return;

    if (ostatniaProbka) {
      var skok = Math.abs(a.x - ostatniaProbka.x) +
                 Math.abs(a.y - ostatniaProbka.y) +
                 Math.abs(a.z - ostatniaProbka.z);
      if (skok > WSTRZAS_PROG) {
        // Jasność podnosi każdy odczyt ponad próg — inaczej najmocniejsza faza
        // szarpnięcia wypadałaby w czasie blokady. Blokada trzyma tylko liczbę
        // dokładanych rozbłysków w ryzach.
        var teraz = Date.now();
        var swiezy = teraz - ostatniWstrzas > WSTRZAS_ODSTEP;
        if (swiezy) ostatniWstrzas = teraz;
        pobudz((skok - WSTRZAS_PROG) / (WSTRZAS_PELNIA - WSTRZAS_PROG), swiezy);
      }
    }
    ostatniaProbka = { x: a.x, y: a.y, z: a.z };
  }

  function podepnijCzujnik() {
    window.addEventListener('devicemotion', odczytRuchu, { passive: true });
  }

  function pamiec(klucz, wartosc) {
    try {
      if (wartosc === undefined) return window.localStorage.getItem(klucz);
      window.localStorage.setItem(klucz, wartosc);
    } catch (e) {
      return null;
    }
  }

  function wlaczCzujnik() {
    var DM = window.DeviceMotionEvent;
    if (!DM) return;

    if (typeof DM.requestPermission !== 'function') {
      podepnijCzujnik();   // Android i starsze iOS — bez pytania
      return;
    }
    if (!PYTAJ_O_RUCH || pamiec('lpn-ruch') === 'nie') return;
    if (pamiec('lpn-ruch') === 'tak') {
      // Zgoda i tak wygasa wraz z sesją, więc pytamy ponownie przy geście.
      DM.requestPermission().then(function (stan) {
        if (stan === 'granted') podepnijCzujnik();
      }).catch(function () {});
      return;
    }
    DM.requestPermission().then(function (stan) {
      pamiec('lpn-ruch', stan === 'granted' ? 'tak' : 'nie');
      if (stan === 'granted') podepnijCzujnik();
    }).catch(function () {});
  }

  // ── przebudowa przy zmianie rozmiarów ───────────────────────────────────
  var opoznienie = null;

  function moznaPrzebudowac() {
    var szer = warstwa.clientWidth || window.innerWidth;
    var wys = Math.round(window.innerHeight +
              Math.max(0, wysokoscStrony() - window.innerHeight) * UDZIAL);
    return Math.abs(szer - ostatniaSzer) > 20 || Math.abs(wys - ostatniaWys) > 60;
  }

  function odswiez() {
    clearTimeout(opoznienie);
    opoznienie = setTimeout(function () {
      if (moznaPrzebudowac()) {
        zbuduj();
        przesun(window.pageYOffset || 0);
      }
    }, 350);
  }

  // ── start ───────────────────────────────────────────────────────────────
  zbuduj();
  przesun(window.pageYOffset || 0);

  // Przeglądarka przywraca pozycję przewinięcia dopiero po wczytaniu, a przy
  // powrocie „wstecz" strona wraca z pamięci podręcznej bez zdarzenia scroll.
  function ustawZPozycji() { przesun(window.pageYOffset || 0); }
  window.addEventListener('load', ustawZPozycji);
  window.addEventListener('pageshow', ustawZPozycji);

  window.addEventListener('resize', odswiez, { passive: true });
  if (window.ResizeObserver && document.body) {
    new ResizeObserver(odswiez).observe(document.body);
  }

  if (!spokoj.matches) {
    window.addEventListener('scroll', ruszyloSie, { passive: true });

    if (window.DeviceMotionEvent) {
      if (typeof window.DeviceMotionEvent.requestPermission === 'function') {
        // iOS: o zgodę wolno prosić dopiero przy geście użytkownika.
        document.addEventListener('pointerdown', wlaczCzujnik, { once: true });
      } else {
        wlaczCzujnik();
      }
    }
    zegar = setTimeout(migaj, calk(400, 1100));
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(zegar);
        zegar = null;
      } else if (!zegar) {
        zegar = setTimeout(migaj, calk(170, 680));
      }
    });
  }
})();
